import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { About } from "../components/About";
import { Services } from "../components/Services";
import { Partners } from "../components/Partners";
import { WhyUs } from "../components/WhyUs";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";
import { WhatsAppFab } from "../components/WhatsAppFab";

export default function Home() {
  const location = useLocation();

  // When navigated to "/#section" from another route, scroll into view once
  // the components are mounted. The brand-specific BrandShowcase listener
  // already handles "#brand:group" anchors separately.
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.slice(1).split(":")[0];
    if (!id) return;
    const tryScroll = (attempts = 0) => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else if (attempts < 10) {
        setTimeout(() => tryScroll(attempts + 1), 120);
      }
    };
    tryScroll();
  }, [location]);

  return (
    <div
      data-testid="home-page"
      className="relative min-h-screen bg-[#a8c8e2] text-slate-900"
    >
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Partners />
        <WhyUs />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
